import React, { useState, useEffect } from 'react';
import { backendGetRequest } from '../../../helpers/callBackend';
import GenericHeader from '../../../components/generic/genericHeader';
import { Typography, List, Skeleton, Button, Grid, Stack } from "@mui/material";
import { Layout, Row, Col, Space } from 'antd';
import InstitutionReconnectItem from './temporaryComponents/institutionReconnectItem';
import OuterBox from '../../../components/generic/arpariBoxes/OuterBox';
// TODO:
// 1. pagination backend request
// 2. move this into dashboard/bankAccounts
// 3. skeleton while loading rather than spinner


function ReconnectBankAccounts() {

	const loadingEntries = [{ isLoaderEntry: true }, { isLoaderEntry: true }]

	const [disconnectedFinicityAccounts, setDisconnectedFinicityAccounts] = useState([]);
	const [disconnectedPlaidAccounts, setDisconnectedPlaidAccounts] = useState([]);
	const [loadingDisconnectedFinicityAccounts, setLoadingDisconnectedFinicityAccounts] = useState(true);
	const [loadingDisconnectedPlaidAccounts, setLoadingDisconnectedPlaidAccounts] = useState(true);
	const [loading, setLoading] = useState(true);
	const [listEntries, setListEntries] = useState(loadingEntries)

	useEffect(() => {
		checkConnections()
	}, []);

	useEffect(() => {
		if (loading) {
			setListEntries([...disconnectedFinicityAccounts, ...disconnectedPlaidAccounts, ...loadingEntries])
		} else {
			setListEntries([...disconnectedFinicityAccounts, ...disconnectedPlaidAccounts])
		}
	}, [loading, disconnectedFinicityAccounts, disconnectedPlaidAccounts])

	useEffect(() => {
		setLoading(loadingDisconnectedFinicityAccounts || loadingDisconnectedPlaidAccounts)
	}, [loadingDisconnectedFinicityAccounts, loadingDisconnectedPlaidAccounts])

	function checkConnections() {

		backendGetRequest('/api/finicity/reconnect', {})
			.then((res) => {
				setDisconnectedFinicityAccounts(res?.data?.data);
				setLoadingDisconnectedFinicityAccounts(false);
			});
		backendGetRequest('/api/plaid-arpari/reconnect', {})
			.then((res) => {
				setDisconnectedPlaidAccounts(res?.data?.data);
				setLoadingDisconnectedPlaidAccounts(false);
			});
	};

	return (
		<OuterBox>
			<Grid container spacing={2}>
				<Grid item xs={12} sx={{ marginTop: 2 }}>
					<Stack spacing={2}>
						<Grid container>
							<Grid item xs={12} sx={{ paddingLeft: 5 }}>
								<Typography variant="h5">
									{!loading && listEntries.length === 0
										? "Nothing to reconnect - all connections are live!"
										: "Please reconnect the following institutions:"}
								</Typography>
							</Grid>
						</Grid>

						<Grid container>
							<Grid item xs={12} sx={{ paddingLeft: 12 }}>
								<List>
									{listEntries.map((item, index) =>
										item.isLoaderEntry ? (
											<List.Item key={index}>
												<Skeleton variant="text" width={100} />
											</List.Item>
										) : (
											item.institution_name && (
												<List.Item key={index}>
													<InstitutionReconnectItem
														institutionName={item.institution_name}
														reconnectURL={item.reconnect_url}
														source={item.source}
														sourceId={item.source_id}
														sourceAccountId={item.source_account_id}
													/>
												</List.Item>
											)
										)
									)}
								</List>
							</Grid>
						</Grid>

						<Grid container>
							<Grid item xs={12} sx={{ marginLeft: 5, marginBottom: 5 }}>
								<Button
									onClick={() => {
										setLoadingDisconnectedFinicityAccounts(true);
										setLoadingDisconnectedPlaidAccounts(true);
										checkConnections();
									}}
									sx={{ fontSize: 14, textTransform: "none" }}
									disableElevation
									fullWidth
									size="small"
									variant="outlined"
									color="secondary"
								>
									Refresh Connections
								</Button>
							</Grid>
						</Grid>
					</Stack>
				</Grid>
			</Grid>
		</OuterBox>
	)
}

export default ReconnectBankAccounts;
